import Emitter from '../core/Emitter.js';

class DataSource extends Emitter {
	constructor(ctx) {
		super();
		this.guid = ctx.guid;
		this.name = ctx.name;
		this.query = ctx.query;

		this.filters = [];
	}

	update(name, query) {
		this.name = name;
		this.query = query;
	}

	getQueryWithFilters() {
		var pipe = !this.filters.length ? '' : '|';
		return `${this.query} ${pipe} ${this.filters.join(' | ')}`;
	}

	getQuery() {
		return this.query;
	}

	getFilters() {
		return this.filters;
	}

	addFilter(filter) {
		this.filters.push(filter);
		this._handleFilterChanged();
	}

	clearAndAddFilter(filter) {
		this.filters.splice(0, this.filters.length);
		this.filters.push(filter);
		this._handleFilterChanged();
	}

	removeFilterAt() {

	}

	removeFilter(filter) {

	}

	clearFilter() {
		this.filters.splice(0, this.filters.length);
		this._handleFilterChanged();
	}

	_handleFilterChanged() {
		var e = new Event('filter');
		e.detail = this.filters;
		this.dispatchEvent(e);
	}
}

export default DataSource;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/data/DataSource.js